// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// IE EXPLORER NEEDS
import "@babel/polyfill";

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Loading from 'components/lib/loading'
import CenterContainer from 'components/lib/center-container'
import 'bootstrap'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faTimesCircle, faArrowLeft, faPlusCircle, faEdit, faStarOfLife, faFilePdf, faTrashRestoreAlt, faEye,faSearch, faFileAlt, faCheck, faBalanceScale, faEuroSign, faClipboardList, faExclamationTriangle, faPrint, faClipboardCheck, faFileDownload, faUser, faPhoneVolume, faInfoCircle, faMinus, faTrashAlt, faCheckCircle, faFileInvoice, faReceipt, faWineBottle, faCamera, faShippingFast, faGlobe, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vueHeadful from 'vue-headful'
import VeeValidator from './utils/vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueScrollTo from 'vue-scrollto'
import VueMoment from 'vue-moment'
//import VueAnalytics from 'vue-analytics'
import CryptoJS from 'crypto-js'
import VueCountdown from '@chenfengyuan/vue-countdown'
Vue.component(VueCountdown.name, VueCountdown);
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////CRYPT DATA///////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
Vue.prototype.$encryptByAES = function (string, key) {
  if (process.env.APP == "PROD") {
    let ckey = CryptoJS.enc.Utf8.parse(key);
    let encrypted = CryptoJS.AES.encrypt(string, ckey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(); // return ciphertext in hex format
  } else {
    return JSON.parse(string)
  }
}
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////DECRYPT DATA/////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
Vue.prototype.$decryptByAES = function (string, key) {
  if (process.env.APP == "PROD") {
    let ckey = CryptoJS.enc.Utf8.parse(key);
    var ciphertext = CryptoJS.enc.Hex.parse(string);
    let srcs = CryptoJS.enc.Base64.stringify(ciphertext);
    let decrypt = CryptoJS.AES.decrypt(srcs, ckey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    let decrypted = decrypt.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted)
  } else {
    return string
  }
}
import Viewer from 'v-viewer'
Vue.use(Viewer)
Viewer.setDefaults({
  fullscreen: true,
  inline: false
})
Vue.prototype.$log = function (string) {
  if (process.env.APP != "PROD") {
    console.log(string)
  }
  return true
}
Vue.prototype.$warn = function (string) {
  if (process.env.APP != "PROD") {
    console.warn(string)
  }
  return true
}
Vue.prototype.$error = function (string) {
  if (process.env.APP != "PROD") {
    console.error(string)
  }
  return true
}
import PayPal from 'vue-paypal-checkout'
Vue.component('paypal-checkout', PayPal)
Vue.component('billing-page', PayPal)

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
  siteKey: '6Le9jeQUAAAAABWhlGbyFaHC2X4EpmKwQZIryQbV',//6Le9jeQUAAAAAOnPo0iTqQHNA_IQiB4I9WFEXYvI
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true
  }
})

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

//Vue.use(VueAnalytics, {
//  id: 'UA-49774803-10',
//  router
//})
/*
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-ST09WDML37" }
}, router);*/
import vSelect from "vue-select";

Vue.component("v-select", vSelect);

// VUE MOMENT
Vue.use(VueMoment);

// Scroll TO
Vue.use(VueScrollTo);

// SWEET ALERT 2
Vue.use(VueSweetalert2);

// HEAD DATA PLUGIN
Vue.component('vue-headful', vueHeadful);
// FONT AWEASOME PLUGIN
Vue.component('font-awesome-icon', FontAwesomeIcon)

// LOADSCREEN
Vue.component('loading', Loading)
// CENTER CONTAINER
Vue.component('center-container', CenterContainer)

Vue.config.productionTip = false

// ADD AWEASOME ICOMS:
library.add(  faSpinner,faArrowLeft, faInfoCircle, faEye, faEdit, faPrint, faFilePdf, faTrashRestoreAlt, faStarOfLife,  faFileAlt, faCheck, faBalanceScale, faEuroSign, faClipboardList, faFileDownload, faExclamationTriangle, faClipboardCheck, faSearch, faUser, faPhoneVolume, faPlusCircle, faMinus, faTimesCircle, faTrashAlt, faCheckCircle, faFileInvoice, faReceipt, faWineBottle, faCamera, faShippingFast, faGlobe, faShoppingCart )

import vueNumeralFilterInstaller from 'vue-numeral-filter';

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.use(vueNumeralFilterInstaller, { locale: 'it' });

Vue.filter("formatNumber", function (value) {
  var value = parseFloat(value)
  return numeral(value).format("0.0,[00]") // displaying other groupings/separators is possible, look at the docs
});


Vue.use(VeeValidator.core, VeeValidator.config);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Loading,
  template: '<App/>',
  components: { App },


})



// WEBPACK FOOTER //
// ./src/main.js